import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        a {
            padding: 7px;
        }
    `,
};

logoStyles.image = {
    css: css`
        height: auto;
        align-items: end !important;
        @media (max-width: 991px) {
            height: 30px;
        }
    `,
};
